/**
 * @file http接口统一管理
 */
import axios from 'axios';
import store from '@/store';
import {clearLoginCookie, messageToLoginPageWaitFor3S} from '@/util/util';
import * as RouterUtil from '@/router/routerUtil';
import * as PageNames from '@/enmus/PageNames';
import {isDev} from '@/util/env';
import {getUuapLoginUrl} from '@/util/uuapUtil';
// import '@baidu/bioc-jssdk';
// import {installAxiosInterceptor} from '@baidu/bioc-request-interceptor';

// 初始化axios
// axios.defaults.baseURL = 'http://vue-admin-master.baidu.com:8410/';
axios.defaults.timeout = 90000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
// axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
// test=kLfL3KIi
// installAxiosInterceptor(axios, {ak: 'ZNyko6NVysDXy5AxERQLblqNnOcdGrSY'});

const supplyIdApiList = [
    '/api/v1/history',
    '/api/v1/history/recordCount',
    '/api/v1/history/download',
    '/api/v1/stat/topBlackIp',
    '/api/v1/stat/knownSpiderDetail',
    '/api/v1/stat/cDistribution',
    '/api/v1/stat/pvTimeSharing',
    '/api/v1/stat/pvTrend',
    '/api/v1/mark'
];

const handleError = (e, config = {}) => {
    // if (config.errorHandle !== false) {
    //     const msg = e.message;
    //     if (msg.includes('Network Error')) { // 网络错误处理
    //         store.state.globalRequestError = true;
    //     }
    // }
};

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params = {}, config = {}) {
    // 需要添加 supplyId 的接口，从cookie中读出当前用户的 supplyId
    if (supplyIdApiList.indexOf(url) > -1) {
        const supplyId = store.state.supplyId;
        params.supplyId = supplyId;
    }
    params.t = new Date().valueOf(); // 解决 get 请求被缓存问题

    return new Promise((resolve, reject) => {
        axios
            .get(url, {...config, params})
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                handleError(err, config);
                reject(err);
            });
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, config = {}) {
    const formData = new FormData();
    Object.keys(params).forEach(key => formData.append(key, params[key]));
    return new Promise((resolve, reject) => {
        axios
            .post(url, formData, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                handleError(err, config);
                reject(err);
            });
    });
}

export function postJSON(url, params, config = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(
                url,
                params,
                Object.assign(config, {
                    headers: {
                        ...(config.headers || {}),
                        'Content-Type': 'application/json;charset=utf-8'
                    }
                })
            )
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                handleError(err, config);
                reject(err);
            });
    });
}

axios.interceptors.request.use(config => {
    // 登录页设置为域名根
    let href = location.href;
    const loginPathname = RouterUtil.getPagePath(PageNames.LOGIN);
    if (location.pathname === loginPathname) {
        href = href.replace(loginPathname, '');
    }
    config.headers.originalUrl = href;
    return config;
});
// http response 服务器响应拦截器，
// 这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(response => {
    // 跳过权限检测
    if (response.config.params?.__ignoreCode) {
        return response;
    }
    // UUAP登录验证失败
    if (response.data?.code === 40001) {
        // zhitong.baidu.com强制跳转到antibot.baidu.com
        response.data.redirectUrl = response.data.redirectUrl?.replace(/zhitong\.baidu\.com/g, 'antibot.baidu.com');
        if (process.env.VUE_APP_ONLINE_PROXY) {
            response.data.redirectUrl = response.data.redirectUrl?.replace(
                /https%3A%2F%2Fantibot\.baidu\.com/g,
                'http%3A%2F%2Fzhitong-castor.baidu.com:8080'
            );
        }
        if (isDev) {
            const url = getUuapLoginUrl(location.origin);
            window.location.href = url;
        } else {
            window.location.href = response.data.redirectUrl;
        }
        return;
    }
    if (response.data.res === -1) {
        // 未登录
        clearLoginCookie();
        window.location.href = RouterUtil.getPagePath(PageNames.LOGIN);
    } else if ([-3, 10].includes(response.data.res)) {
        // -3 无权限 或者 10 权限发生变化
        clearLoginCookie();
        messageToLoginPageWaitFor3S();
    } else {
        return response;
    }
});
